import React from 'react';

const SkeletonLoader = ({ width = "100%", height = "20px", borderRadius = "4px", className = "", style = {}, count = 1 }) => {
    const skeletons = [];
    for (let i = 0; i < count; i++) {
        skeletons.push(
            <div 
                key={i} 
                className={`skeleton-loader ${className}`}
                style={{ 
                    width, 
                    height, 
                    borderRadius, 
                    marginBottom: i < count - 1 ? '10px' : 0,
                    animation: "skeleton-pulse 1.5s ease-in-out infinite",
                    backgroundColor: "#e2e8f0",
                    ...style 
                }}
            />
        );
    }
    return (
        <>
            <style>{`
                @keyframes skeleton-pulse {
                    0% { opacity: 1; }
                    50% { opacity: 0.4; }
                    100% { opacity: 1; }
                }
            `}</style>
            {skeletons}
        </>
    );
};

export default SkeletonLoader;
